import {
  STRONG_PASSWORD_REGEX,
  VALID_PHONE_REGEX,
} from '../../../utils/helpers/CommonHelper';

export const required = (t) => ({
  required: true,
  message: t('Pole je povinné'),
});

export const empty = (t) => ({
  required: true,
  validator: (_, value) => {
    if (value && value.trim() !== '') {
      return Promise.resolve();
    } else {
      return Promise.reject(t('Pole nesmie byť prázdne'));
    }
  },
});

export const emptyEditor = (t) => ({
  required: true,
  validator: (_, value) => {
    if (typeof value !== 'string' || value.trim() === '') {
      return Promise.reject(t('Pole nesmie byť prázdne'));
    }

    let div = document.createElement('div');
    div.innerHTML = value;
    const textContent = div.innerText ? div.innerText.trim() : '';
    if (textContent !== '') {
      return Promise.resolve();
    } else {
      return Promise.reject(t('Pole nesmie byť prázdne'));
    }
  },
});

export const url = (t) => ({
  type: 'url',
  message: t('Pole obsahuje neplatnú URL adresu'),
});

export const email = (t) => ({
  type: 'email',
  message: t('Pole obsahuje neplatnú e-mailovú adresu'),
});

export const number = (t, min = 0, max = Number.MAX_SAFE_INTEGER) => ({
  type: 'number',
  message: t('Pole obsahuje neplatné číslo'),
  min,
  max,
});

export const phone = (t) => ({
  validator: (_, value) => {
    if (VALID_PHONE_REGEX.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(t('Pole obsahuje neplatné telefónne číslo'));
  },
});

export const strongPassword = (t) => ({
  validator: (_, value) => {
    if (STRONG_PASSWORD_REGEX.test(value)) {
      return Promise.resolve();
    }

    return Promise.reject(
      t(
        'Heslo musí mať aspoň 8 znakov a musí obsahovať aspoň 1 písmeno a 1 číslicu',
      ),
    );
  },
});
